<!-- 404 page -->
<div class="m-auto w-50 text-center pt-5">
  <h1 class="mat-headline mat-display-1 mb-0">{{'page_not_found' | transloco}}</h1>
  <p class="mb-0 pnf-text">404</p>
  <button mat-raised-button (click)="navigateToHomePage()" class="submit-small-button shadow-none mt-3">{{'back_to_home' | transloco}}</button>
</div>
<!-- 404 page -->
